/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Durable live-state observation. Replaces the legacy sticky isLive boolean. Read code should consume effectiveLiveState (server-projected), not this raw value.
 * @export
 */
export const LiveState = {
    LIVE: 'LIVE',
    OFFLINE: 'OFFLINE'
} as const;
export type LiveState = typeof LiveState[keyof typeof LiveState];


export function instanceOfLiveState(value: any): boolean {
    for (const key in LiveState) {
        if (Object.prototype.hasOwnProperty.call(LiveState, key)) {
            if (LiveState[key as keyof typeof LiveState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LiveStateFromJSON(json: any): LiveState {
    return LiveStateFromJSONTyped(json, false);
}

export function LiveStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiveState {
    return json as LiveState;
}

export function LiveStateToJSON(value?: LiveState | null): any {
    return value as any;
}

export function LiveStateToJSONTyped(value: any, ignoreDiscriminator: boolean): LiveState {
    return value as LiveState;
}

